import React, { Component } from 'react';
import { connect } from 'react-redux';

import CdnImage from "../../general/cdnImage/cdnImage";
import SwitchSelector from "react-switch-selector";

const stateManager = require('../../../../utils/state/stateManager.js');
const basketUtil = require('../../../../utils/basket/basketUtil.js');
const stringUtil = require('../../../../utils/string/stringUtil');
const storeUtil = require('../../../../utils/store/storeUtil');
const constants = require('../../../../utils/domain/constants');

class Header extends Component 
{
    render()
    {
        var state = stateManager.getStore().getState();
        const logoUrl = state.storefront.logoImageUrl ?? state.brand.logoUrl ?? state.franchisor.logoImageUrl;
        const width = Math.round(window.innerWidth * 0.3);
        const height = Math.round(window.innerWidth * 0.18);

        return  <div>
                    <table width="100%">
                        <tr>
                            <td style={{width:'1%', whiteSpace:'nowrap'}}>
                                <div style={{ margin: '0px 0px 0px 60px' }}>
                                    <CdnImage publicId={logoUrl} width={width} height={height} />
                                </div>
                            </td>
                            <td style={{verticalAlign: 'top'}}>
                                <div style={{marginLeft:'10px', marginRight:'10px', marginTop: '15px'}}>
                                    <h1 style={{fontWeight:'bold', marginBottom:'5px'}}>{state.property.name}</h1>
                                    <div className='body'>{state.property.address}</div>         
                                    {   stringUtil.areStringSame(stateManager.getStore().getState().currentMode, constants.applicationMode.overPhonePayment)
                                        ? null
                                        : <div style={{display:'flex', flexDirection:'row', overflowX:'auto'}}> 
                                            <div className="ratingsText"><i className="fa fa-star"></i>&nbsp;{state.property.reviewsRating}</div>
                                            <div className="body" style={{marginLeft: '5px'}}>({state.property.reviewsCount})</div>
                                        </div>
                                    }
                                                               
                                </div>
                            </td>
                        </tr>
                    </table>

                    {
                        stringUtil.areStringSame(stateManager.getStore().getState().currentMode, constants.applicationMode.overPhonePayment)
                            ? null 
                            : this.getDispatchTypeOptionsWidget()
                    }
                    
                </div>
    }

    getDispatchTypeOptionsWidget()
    {
        var state = stateManager.getStore().getState();
        if (state.currentMenu == null)
            return null;

        const availableDispatchTypes = state.allowedDispatchTypes.filter(dispatchTypeConfiguration => !storeUtil.isStoreClosedForDispatchType(dispatchTypeConfiguration.dispatchType));

        if(availableDispatchTypes.length === 0)
            return null;

        var options = [];

        availableDispatchTypes.forEach(dispatchTypeConfiguration =>
        {
            let option = {};
            option.label = dispatchTypeConfiguration.dispatchType;
            option.value = dispatchTypeConfiguration.dispatchType;
            options.push(option);
        });
        var index = availableDispatchTypes.findIndex(aD => stringUtil.areStringSame(aD.dispatchType, state.basket.order.dispatchType));
        

        return <div style={{margin:'20px 60px 0px 60px', height: 50}}>
                    <SwitchSelector
                    onChange={this.onDispatchTypeChange}
                    options={options}
                    initialSelectedIndex={index}
                    backgroundColor={`var(--switch_selector-background-color)`}
                    selectedBackgroundColor={`var(--switch_selector-selected-background-color)`}
                    fontColor={`var(--switch_selector-font-color)`}
                    selectedFontColor={`var(--switch_selector-selected-font-color)`}
                    optionBorderRadius={10}
                    wrapperBorderRadius={10}
                    border={200}/>
                </div>
    }

    onDispatchTypeChange(selectedDispatchOption)
    {
        basketUtil.resetBasket(selectedDispatchOption)
    }
}

const mapStateToProps = state => 
{
    return { 
        basketVersion: state.basketVersion,
    }
}

export default connect(mapStateToProps)(Header)